/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import SocialAvatar from 'app/components/common/SocialAvatar.jsx';
import Loading from 'app/components/common/Loading.jsx';
import Modal from 'app/components/common/Modal.jsx';
import Visibility from 'app/utility/visibility.js';

class FacebookGroupModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            groupsLoaded: false,
            pageVisible: 'visible',
            groups: []
        };

        this.visibilityCallback = this.visibilityCallback.bind(this);

    }

    static getDerivedStateFromProps(props, state) {
        let constants = props.app.config.constants,
            groups = [];

        if (props.app.firstLoad.SOCIAL_LIST && state.groups.length === 0 && state.groupsLoaded === false) {
            for (let i = 0; i < props.socials.list.length; ++i) {
                let social = props.socials.list[i];
                if (parseInt(social.psID) == constants.POST_SVC_FACEBOOK && parseInt(social.subType) == constants.FB_GROUP && social.hasGroupApp !== undefined && social.hasGroupApp === 0) {
                    groups.push(social);
                }
            }
            return {
                groups,
                groupsLoaded: true
            };
        }

        return null;

    }

    componentDidMount() {
        Visibility.attach(this.visibilityCallback);
    }

    componentWillUnmount() {
        Visibility.detach(this.visibilityCallback);
    }

    visibilityCallback(nextState) {
        let currentState = this.state.pageVisible;

        if (currentState === 'hidden' && nextState === 'visible') {
            this.state.groups.map((social) => {
                this.props.getFacebookGroupStatus(social.id);
            });

        }
        this.setState({
            pageVisible: nextState
        });
    }

    render() {
        let headerContent = "Add dlvr.it to these Facebook Groups",
            menuContent = null,
            content = null,
            footerContent = null,
            groups = [],
            constants = this.props.app.config.constants;

        if (this.state.groups.length) {
            content = (
                <div>
                    <div className="social-notification-wrapper">
                        <ul className="social-notification-list">
                            {this.state.groups.map(function(social, i) {
                                let element = null,
                                    button = null,
                                    constants = this.props.app.config.constants,
                                    propsSocial = this.props.socials.list.find((propsSocial) => { return propsSocial.id === social.id; });

                                if (propsSocial && propsSocial.hasGroupApp === 1) {
                                    button = (
                                        <div className="group-added-check">
                                            <i className="icon ion-android-checkmark-circle"></i>
                                        </div>
                                    );
                                } else {
                                    button = (
                                        <button className="btn-flat group-reconnect" onClick={() => {
                                                window.open("https://www.facebook.com/groups/" + social.externalID + "/edit/");
                                            }}>
                                            Add dlvr.it app
                                        </button>
                                    );
                                }

                                element = (
                                    <li key={i} className="social-notification-item">
                                        <div className="avatar-element">
                                            <SocialAvatar
                                                social={social}
                                                wrapperClass="standalone-avatar-wrapper"
                                                type="standalone"
                                                large={true}/>
                                        </div>
                                        <div className="social-info">
                                            <div className="social-name">
                                                {social.name}
                                            </div>
                                            <div className="social-notice">
                                                The dlvr.it app needs to be added to this Facebook group. <a href="https://support.dlvrit.com/hc/en-us/articles/360007690813" target="_blank">Learn how</a>
                                            </div>
                                        </div>
                                        <div className="group-reconnect">
                                            {button}
                                        </div>
                                    </li>
                                );

                                return element;

                            }.bind(this))}
                        </ul>

                    </div>
                    <div className="close-group-modal">
                        <button className="btn-primary fixed active" onClick={() => {
                                this.props.setModal();
                            }}>
                            {"I'm done"}
                        </button>
                    </div>
                </div>
            );
        } else {
            content = <Loading />;
        }

        return (
            <Modal
                close={this.props.setModal}
                headerContent={headerContent}
                menuContent={menuContent}
                content={content}
                footerContent={footerContent}
                contentClass="reconnect-modal groups modal-content-padding"/>
        );
    }
}

FacebookGroupModal.displayName = "FacebookGroupModal";

FacebookGroupModal.propTypes = {

};

FacebookGroupModal.defaultProps = {

};

export default FacebookGroupModal;
